import $ from 'jquery';

const whitelistArray = [
    'site-nav__link',
    'dropdown-toggle'
];



function initUI() {
    $(window).on("load", function () {
        setListeners();
        if (location.hash) {
            setTimeout(function () {
                actionUI(false, 'anchor');

            }, 1);
        }
    });
}

function actionUI(event, action) {

    // return;
    var classes = event.currentTarget.className;
    var n = whitelistArray.includes(classes);

    //console.log("n: " + n);
    //console.log(event);

    if (event) {
     //   event.preventDefault();
    } else {
        return;
    }



    let href = '';
    switch (action) {
        case 'page':
            href = event.currentTarget.href;
            if (href) {

                action = false;
                $('body').addClass('exit');
                setTimeout(function () {
                    window.location = href;
                }, 250);
                return;
            }

            break;
        case 'anchor':
            var targetSelector = '';
            if (!event) {
                targetSelector = window.location.hash;
            } else {
                targetSelector = $(event.target).attr('href');
            }

            var targetTop = $("a" + targetSelector).offset().top - 100;
            $('html, body').animate({
                scrollTop: targetTop,
            }, 400, null, function () {
                // //console.log("all done");
            });
            setAnchorPath(targetSelector);
            break;
        case 'unfold':

            $('.article-list li.unfolded').removeClass('unfolded');
            $(event.target.closest('li')).addClass('unfolded');

            break;
        case 'default':

            // case 'default':
            href = event.currentTarget.href;
            var classes = event.currentTarget.className;
            var n = href.includes("#");

            if (href && !n) {

                // action = false;
                $('body').addClass('exit');
                setTimeout(function () {
                    window.location = href;
                }, 100);

            } else {
                //console.log('prevented!');
            }


            break;

        default:


            break;


        // targetTop = $(location).attr('hash');
        // //console.log('DEFAULT ACTION UIT!!! blalablalblalba');
        //   actionUI('anchor',)
    }
}

function setAnchorPath(anchorTarget) {

    var cleanLocation = location.href.replace(location.hash, "");
    cleanLocation = cleanLocation.replace("#", "");

    if (anchorTarget !== '#intro') {
        cleanLocation += anchorTarget;
    } else {
        cleanLocation += '#';
    }

    window.location.replace(cleanLocation);

}

function setListeners() {

    $('.action-anchor').on('click', function (event) {
        actionUI(event, 'anchor');
    });

    $('.link-wrapper .arrow').on('click', function (event) {
        actionUI(event, 'unfold');
    });


    // FADE OUT TRANSITION
    /*
    $('a').on('click', function (event) {

        let e = $(this).data('event');
        if (e) {
            actionUI(event, e);
        }
        // else {
        //     actionUI(event, 'default');
        // }
    });
    */

    // header
    $('.c-ppc-adelheid__header-navigation__item:not(.has-sub-menu):not(.active) >.nav-title a').on('click', function (event) {
        actionUI(event, 'default');
    });

    
    // // content
    // $('.page-wrapper a').on('click', function (event) {

    //     actionUI(event, 'default');
    // });


}

export default initUI;

